const articles = [
    {
        id: 1,
        title: 'Harmony and Heart: The Significance of Ballads in Show Choir Performances',
        image: 'images/article1/1.jpg',
        subtitle: "Discover how the heartfelt power of ballads transforms show choir performances, creating emotional connections, unforgettable moments, and a profound depth that captivates audiences."
    },
    {
        id: 2,
        title: 'In Your Seat: A First-Time Audience Member’s Guide to the Show Choir Competition',
        image: 'images/article2/1.jpg',
        subtitle: "If you're a first-time audience member, get ready to immerse yourself in the magic, anticipation, and joy of a show choir competition, where breathtaking performances and shared excitement create an unforgettable experience."
    },
    {
        id: 3,
        title: 'Show Choir Contest: Where More Than Music Takes Flight',
        image: 'images/article3/1.jpg',
        subtitle: 'See how show choir contests are a celebration of dedication, artistry, and personal growth, where young performers unite their passion for music and dance to inspire audiences, forge connections, and elevate their communities.'
    },
    {
        id: 4,
        title: "Show Choir: Where Excellence and Success Harmonize",
        image: 'images/article4/1.jpg',
        subtitle: "Learn how show choir members exemplify the harmonious blend of artistic talent, academic excellence, and personal growth, proving that their dedication to music and performance fosters a foundation for lifelong success and achievement."
    },
    {
        id: 5,
        title: "From School Stage to Broadway Spotlight – The Show Choir Path to Stardom",
        image: 'images/article5/1.jpg',
        subtitle: 'Discover how the vibrant world of high school show choir lays the foundation for Broadway stardom, with inspiring stories of performers who turned their school stage dreams into Tony-Winning realities.'
    },
    {
        id: 6,
        title: "Harmonious Showdown: Deciphering the art of Judging High School Show Choir Contest",
        image: 'images/article6/1.jpg',
        subtitle: 'Uncover the artistry and precision behind judging high school show choir contests, and gain a deeper appreciation for the talent, dedication, and creativity that make each performance unforgettable.'
    },
    {
        id: 7,
        title: "Harmonizing Hearts: The Inspiring Role of the Audience in a Show Choir Contest",
        image: 'images/article7/1.jpg',
        subtitle: 'Discover how your role as an audience member transforms a show choir contest into a symphony of support, respect, and unforgettable unity.'
    },
    {
        id: 8,
        title: "Harmonizing Moves: Exploring the Diverse Styles of Show Choir Choreography",
        image: 'images/article8/1.jpg',
        subtitle: "Explore the dynamic world of show choir choreography, where diverse styles and innovative moves combine to elevate performances into captivating visual and musical masterpieces."
    },
    {
        id: 9,
        title: "Show Choir’s Culinary Harmony: Recipes from Coast to Coast",
        image: 'images/recipes.jpg',
        subtitle: 'Discover the heartwarming flavors and traditions behind show choir gatherings with these cherished recipes shared by show choir families from across the country.'
    },


    {
        id: 10,
        title: "Spotlight and Sound: The Rise of Show Choir in America",
        image: 'images/history/5.jpg',
        subtitle: 'Discover the rich history, cultural evolution, and enduring impact of American show choirs, from their humble beginnings to the electrifying performances that captivate audiences today.'
    },



    {
        id: 11,
        title: "Echoes of Harmony",
        image: 'images/snow2.png',
        subtitle: "Amid a snowstorm and the electrifying pulse of a show choir championship, three strangers forge an unbreakable bond, proving that life's most extraordinary moments often bloom in the most unexpected places—this is a fictional short story."
    },


    {
        id: 12,
        title: "From Choir to Fame: How High School Choirs Shaped America's Greatest Talents",
        image: 'images/famous2.png',
        subtitle: 'Discover the famous people who found their voices in high school choirs—where harmony inspired success!'
    },


    {
        id: 13,
        title: "Life After the Spotlight: Navigating the Post-Show Choir Season",
        image: 'images/article13/preview.png',
        subtitle: 'Discover how to transition from the whirlwind of show choir season to a fulfilling new rhythm for your family.'
    },


    {
        id: 14,
        title: "The Evolution of Show Choir Outfits: A Sparkling History",
        image: 'images/article14/3.jpg',
        subtitle: 'Dive into the dazzling history of show choir fashion and discover how costumes became as dynamic as the performances themselves.'
    },

    {
        id: 15,
        title: "The College Connection: Schools with Show Choir Programs and Opportunities",
        image: 'images/costumes.jpg',
        subtitle: 'Explore how high school show choir experience can set the stage for college success with scholarships, vibrant campus communities, and performance opportunities at top universities.'
    }

]

export default articles
